import { useMediaQuery } from "./useMediaQuery";

const MOBILE_MAX = 1023;

export function useIsMobile(breakpoint = MOBILE_MAX): boolean {
  return useMediaQuery(`(max-width: ${breakpoint}px)`);
}
